import Link from 'next/link';
import Storefront from '@/libraries/shopify/class';
import Credentials from 'next-auth/providers/credentials';
import { Shopify , ShopifyRefresh } from '@/auth/providers/shopify';


/**
*
*   Config Data
*       - The Config Data
*
**/
const Config = {


	//The Shop ID
	shopId: process.env.NEXT_PUBLIC_SHOP_ID,


	//The Domain
	domain: ( process.env.NEXT_PUBLIC_DOMAIN || process.env.VERCEL_URL ),


	//Country
	country: process.env.NEXT_PUBLIC_COUNTRY,


	//The Store Currency
	currency: ( process.env.NEXT_PUBLIC_COUNTRY == 'US' ? 'USD' : 'CAD' ),


	//The Admin emails
	emails: {
		primary: 'info@fernandpetal.com'
	},


	//Social Accounts
	social: {
		facebook:   'fernandpetal.ca',
		instagram:  'fernandpetal.ca'
	},


	//System Versions
	versions: {
		images: '/assets/v/1/'
	},


	//Samples
	samples: [{
		id: 'gid://shopify/Product/6810006323235',
		requirement: 80,
		button: 'Components.Cart.gifts.button'
	},{
		id: 'gid://shopify/Product/6810030899235',
		type: 'birthday',
		button: 'Components.Cart.gifts.birthday'
	}],


	//The Free Shipping
	shipping: process.env.NEXT_PUBLIC_FREE_SHIPPING,


	//Points per dollar
	points: 20,


	//The available rewards
	rewards: {
		'birthday-gift': {
			value:      5,
			repeatable: false,
			lookup:     false
		},
		'welcome-points': {
			value:      50,
			repeatable: false,
			lookup:     false
		},
		'facebook-like': {
			value:      15,
			repeatable: false,
			lookup:     false
		},
		'follow-instagram': {
			value:      15,
			repeatable: false,
			lookup:     false
		},
		'join-newsletter': {
			value:      25,
			repeatable: false,
			lookup:     false
		},
		'facebook-share': {
			value:      20,
			repeatable: false,
			lookup:     false
		},
		'twitter-share': {
			value:      20,
			repeatable: false,
			lookup:     false
		},
		'review': {
			value:      10,
			repeatable: true,
			lookup:     'Product'
		},
		'testimonial': {
			value:      100,
			repeatable: false,
			lookup:     false
		},
		'place-an-order': {
			value:      1,
			repeatable: true,
			lookup:     false
		}
	},

	//Shopify SEttings
	shopify: {

		//Tracking Cookies
		cookies: {
			hasUserConsent: true,
			domain: process.env.NEXT_PUBLIC_DOMAIN.replace(/https?:\/\//,''),
			checkoutDomain: `checkout.${  process.env.NEXT_PUBLIC_DOMAIN.replace(/https?:\/\//,'') }`
		}

	},


	//Wholesale Settings
	wholesale: {


		//Wholesale Tags
		tags: [ 'Wholesale' , 'Maker' ],


		//Wholesale threshold for free shipping
		shipping: process.env.NEXT_PUBLIC_WHOLESALE_SHIPPING,


		//Shipping Flat Rate
		rate: process.env.NEXT_PUBLIC_WHOLESALE_FLAT_RATE


	},

	//Domains
	domains: [{


		//Testing
		domain:         'localhost:3000',
		defaultLocale:  'en',
		locales:        ['en','fr']


	},{


		//Testing
		domain:         'local.fernandpetal.ca:3000',
		defaultLocale:  'en',
		locales:        ['en','fr']


	},{


		//Staging
		domain:         'fern-petal.vercel.app',
		defaultLocale:  'en',
		locales:        ['en','fr']


	},{


		//USA Website
		domain:         'fernandpetal.com',
		defaultLocale:  'en',
		locales:        ['en'],
		country:        'US'


	},{


		//CA Website
		domain:         'fernandpetal.ca',
		defaultLocale:  'en',
		locales:        ['en','fr'],
		country:        'CA'


	}],


	//Localization Config
	i18n: {


		//The Default Timezone
		timeZone: 'America/Vancouver',


		//The HTML Translations
		html: {
			profile:    (chunks) => (<Link href="/account">{ chunks }</Link>),
			login:      (chunks) => (<Link href="/account/login">{ chunks }</Link>),
			register:   (chunks) => (<Link href="/account/register">{ chunks }</Link>),
			contact:    (chunks) => (<a href="mailto:info@fernandpetal.com">{ chunks }</a>),
			strong:     (chunks) => (<strong>{ chunks }</strong>),
			em:         (chunks) => (<em>{ chunks }</em>),
			code:       (chunks) => (<code>{ chunks }</code>),
			small:      (chunks) => (<small>{ chunks }</small>),
			br:         ()       => (<br />)
		},


		// A list of all locales that are supported
		locales: [
			'en',
			'fr'
		],


		//Default Locale
		defaultLocale: 'en',


		//Don't use primary locale folder
		localePrefix: {
			mode: 'as-needed'
		}
	},



	//Next-Auth Config
	Auth: {
		pages: {
			signIn:        '/account/login',
			//signOut:       '/account/logout',
			error:         '/account/login', //Error code passed in query string as ?error=
			verifyRequest: '/account/verify', // (used for check email message)
			newUser:       '/account/register' // New users will be directed here on first sign in (leave the property out if not of interest)
		},
		session: {
			strategy: 'jwt',
			maxAge: 7 * 24 * 60 * 60 // 7 days
		},
		jwt: {
			secret: process.env.NEXTAUTH_SECRET,
			maxAge: 7 * 24 * 60 * 60
		},
		providers: [


			//Shopify oAuth
			Shopify({
				shopId:         process.env.NEXT_PUBLIC_SHOP_ID,
				shopDomain:     ( process.env.NEXT_PUBLIC_DOMAIN || process.env.VERCEL_URL ).replace(/(:[0-9]+)/,''),
				clientId:       process.env.NEXT_PUBLIC_SHOPIFY_CUSTOMER_TOKEN,
				clientSecret:   process.env.SHOPIFY_CUSTOMER_SECRET
			}),


			//Shopify Storefront Credentials
			Credentials({
				name: 'Credentials',
				credentials: {
					email: {
						type: 'text'
					},
					password: {
						type: 'password'
					}
				},
				async authorize(credentials){

					//Get an Access Token
					const login = await Storefront.Customer.login(
						credentials.email,
						credentials.password
					);

					//Throw an Error
					if( !login.result )
						throw new Error( JSON.stringify(login) );

					//Return the Customer
					return {
						...login.body,
						authType: 'storefront',
						id: ( login.body.id || login.body.email )
					};
				}
			})


		],
		callbacks: {
			jwt: async ({ token, user, account, profile }) => {
				user && (token.id           = user.id );
				user && (token.accessToken  = ( user.accessToken || account.access_token ) );
				user && (token.expiresAt    = ( user.expiresAt || account.expires_at ) );
				user && (token.refreshToken = ( user.refreshToken || account.refresh_token ) );
				user && (token.authType     = ( user.authType || account.auth_type ) );

				//Refresh Token
				if( token.authType == 'customer' && new Date() > new Date( token.expiresAt ) )
					return await ShopifyRefresh({
						token,
						shopId:         process.env.NEXT_PUBLIC_SHOP_ID,
						shopDomain:     ( process.env.NEXT_PUBLIC_DOMAIN || process.env.VERCEL_URL ).replace(/(:[0-9]+)/,''),
						clientId:       process.env.NEXT_PUBLIC_SHOPIFY_CUSTOMER_TOKEN,
						clientSecret:   process.env.SHOPIFY_CUSTOMER_SECRET
					});

				return token;
			},
			session: async ({ session, token }) => {
				token && session?.user && ( session.user.id = token.id );
				session.accessToken = ( token.accessToken || token.access_token );
				session.expiresAt   = ( token.expiresAt || token.expires_at );
				session.authType    = ( token.authType || token.auth_type );
				return session;
			}
		}
	}


};

export default Config;